<template>
  <div class="atividades-abastecimentos ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="3">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <label for="select-garagem_sol">Filial</label>
          <multiselect
            id="selecao-filial-sol"
            v-model="value_filial"
            required
            :options="filiais"
            :multiple="true"
            :taggable="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <label for="select-status">status</label>
          <multiselect
            id="selecao-status-sol"
            v-model="value_status"
            required
            :options="statuss"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="status"
            label="status"
            track-by="status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} status selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="1">
          <div>
            <label for="datepicker-placeholder">Data abastecimento</label>
            <b-form-datepicker
              id="dt_sol_final"
              required
              v-model="dt_abastecimento"
              placeholder="Data do final"
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="1">
          <br />
          <b-button
            variant="success"
            class="mr-2 mt-2"
            @click="loadabastecimento()"
          >
            Pesquisar
          </b-button>
        </b-col>

        <b-col cols="2" class="mb-0">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Registro ou Nº do carro"
          ></b-form-input>
        </b-col>

        <!-- condicional para exibir o botão planilha-->
        <b-col cols="1">
          <br />
          <b-button
            variant="success"
            class="mr-2 mt-2"
            v-b-modal.modal-abastecimentoLancamentos
            @click="loadEmpresaCad()"
          >
            Novo
          </b-button>
        </b-col>
      </b-row>
      <LoadingModal v-if="isLoading" />
    </b-form>

    <b-row>
      <b-card-group class="ml-3 mt-3" deck>
        <b-card
          class="ml-2"
          style="width: 33rem"
          border-variant="primary"
          header="Quantidade de carros"
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ new Set(itemsFiltered.map((item) => item.prefixo)).size }}
            </h2>
          </b-card-text>
        </b-card>

        <b-card
          class="ml-2"
          style="width: 33rem"
          border-variant="primary"
          header="Total de lançamentos"
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{ itemsFiltered.length }}
            </h2>
          </b-card-text>
        </b-card>

        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="success"
          header="Diesel consumo"
          header-bg-variant="success"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{
                itemsFiltered
                  .reduce(
                    (total, item) => total + parseFloat(item.combustivel),
                    0
                  )
                  .toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
              }}
            </h2>
          </b-card-text>
        </b-card>

        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="success"
          header="Óleo reposição consumo"
          header-bg-variant="success"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{
                itemsFiltered
                  .reduce(
                    (total, item) => total + parseFloat(item.reposicao),
                    0
                  )
                  .toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
              }}
            </h2>
          </b-card-text>
        </b-card>

        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="success"
          header="Arla consumo"
          header-bg-variant="success"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{
                itemsFiltered
                  .reduce((total, item) => total + parseFloat(item.arla), 0)
                  .toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
              }}
            </h2>
          </b-card-text>
        </b-card>

        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="success"
          header="Km rodado"
          header-bg-variant="success"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{
                itemsFiltered
                  .reduce(
                    (total, item) => total + parseFloat(item.km_rodado),
                    0
                  )
                  .toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
              }}
            </h2>
          </b-card-text>
        </b-card>

        <b-card
          class="mr-2"
          style="width: 33rem"
          border-variant="success"
          header="Média consumo litros"
          header-bg-variant="success"
          header-text-variant="white"
          align="center"
        >
          <b-card-text>
            <h2>
              {{
                value_status.map((s) => s.id) == 1
                  ? "0,00"
                  : (
                      itemsFiltered.reduce(
                        (total, item) => total + parseFloat(item.km_rodado),
                        0
                      ) /
                      itemsFiltered.reduce(
                        (total, item) => total + parseFloat(item.combustivel),
                        0
                      )
                    ).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
              }}
            </h2>
          </b-card-text>
        </b-card>
      </b-card-group>
    </b-row>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      id="saclancamentos"
      small
      hover
      striped
      sticky-header="756px"
      :items="itemsFiltered"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="
            loadCarregarabastecimento(data.item),
              loadEmpresaCad(),
              loadFiliaisCad(),
              loadStatus(),
              loadBombas(),
              loadVeiculo(),
              loadOperador()
          "
          title="Editar abastecimento"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-abastecimentoLancamentos
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  inicio modal gravação do abastecimento  -->
    <!--  inicio modal gravação do abastecimento  -->
    <!--  inicio modal gravação do abastecimento  -->
    <!--  MODAL SOLICITÇÕES  -->
    <div>
      <b-modal
        id="modal-abastecimentoLancamentos"
        centered
        hide-footer
        size="xl"
        @close="reset()"
        :title="`Cadastro de abastecimento Nº.: ${
          abastecimento.id == null ? nroabastecimento : abastecimento.id
        }`"
        no-close-on-esc
        no-close-on-backdrop
      >
        <div>
          <b-row>
            <b-col sm="5" class="mt-1">
              <label for="input-parecer">Empresa</label>
              <div>
                <b-form-select
                  id="infoTipo"
                  v-model="abastecimento.empresa_id"
                  :options="empresas"
                  class="mb-3"
                  text-field="nomeempresarial"
                  @change="loadFiliaisCad()"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col sm="4" class="mt-1">
              <label for="input-parecer">Filial</label>
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="abastecimento.filial_id"
                  :options="filiais"
                  class="mb-3"
                  text-field="filial"
                  @change="loadbombas()"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <label for="input-live">Data abastecimento</label>
              <b-input-group-text>{{
                abastecimento.dt_cadastro != null
                  ? moment(abastecimento.dt_cadastro)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-")
                  : "-"
              }}</b-input-group-text>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="2" class="mt-1">
              <label for="input-live">Carro</label>
              <b-form-input
                v-model="abastecimento.prefixo"
                @keyup.enter="loadVeiculo()"
                required="required"
                placeholder="Nro carro"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-1">
              <label for="input-live">Placa</label>
              <b-input-group-text>{{
                veiculos.map((at) => at.placa).join(", ")
              }}</b-input-group-text>
            </b-col>

            <b-col cols="8" class="mt-1">
              <label for="input-live">Chassi</label>
              <b-input-group-text>{{
                veiculos.map((at) => at.chassi).join(", ")
              }}</b-input-group-text>
            </b-col>
          </b-row>

          <!-- Odometro veiculo-->
          <b-row>
            <b-col cols="4" class="mt-1">
              <label for="input-live">Odometro anterior</label>
              <b-form-input
                id="infoAssunto"
                v-model="abastecimento.od_inicial"
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-1">
              <label for="input-live">Odometro final</label>
              <b-form-input
                id="infoAssunto"
                v-model="abastecimento.od_final"
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-1">
              <label for="input-live">Km rodado</label>
              <b-input-group-text>{{
                abastecimento.km_rodado ? abastecimento.km_rodado : "-"
              }}</b-input-group-text>
            </b-col>
          </b-row>

          <!-- consumo veiculo-->
          <b-row>
            <b-col cols="4" class="mt-1">
              <label for="input-live">Diesel</label>
              <b-form-input
                id="infoAssunto"
                v-model="abastecimento.combustivel"
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-1">
              <label for="input-live">Reposição</label>
              <b-form-input
                id="infoAssunto"
                v-model="abastecimento.reposicao"
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-1">
              <label for="input-live"
                >Arla <i class="fas fa-sign-in-alt"></i
              ></label>
              <b-form-input
                id="infoAssunto"
                v-model="abastecimento.arla"
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="2" class="mt-1">
              <label for="input-live">R.E abastecedor</label>
              <b-form-input
                id="infoAssunto"
                v-model="abastecimento.re_abastecedor"
                @keyup.enter="loadOperador()"
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-1">
              <label for="input-live">Função</label>
              <b-input-group-text>{{ abastecedor.funcao }}</b-input-group-text>
            </b-col>

            <b-col sm="2" class="mt-1">
              <label for="input-parecer">Bomba</label> --
              {{ abastecimento.bomba_id }}
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="abastecimento.bomba_id"
                  :options="bombas"
                  class="mb-3"
                  text-field="bomba"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="4">
              <label for="input-live">Data alteração</label>
              <b-input-group-text>{{
                abastecimento.dt_alteracao != null
                  ? moment(abastecimento.dt_alteracao)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-")
                  : "-"
              }}</b-input-group-text>
            </b-col>
          </b-row>

          <!-- envolvidos -->

          <b-row>
            <b-col cols="12">
              <b-form-textarea
                id="infoConteudo"
                v-model="abastecimento.observacoes"
                size="sm"
                rows="6"
                placeholder="Informações do abastecimento"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <!-- </form> -->
          <b-button
            class="mt-3"
            variant="success"
            block
            @click="postabastecimento(), loadabastecimento()"
            >Gravar abastecimento</b-button
          >
        </div>
      </b-modal>
    </div>
    <!--  fim -  modal gravação do abastecimento  -->
    <!--  fim -  modal gravação do abastecimento  -->
    <!--  fim -  modal gravação do abastecimento  -->

    <!--  inicio modal fotos do abastecimento  -->
    <!--  inicio modal fotos do abastecimento  -->
    <!--  inicio modal fotos do abastecimento  -->
    <!--  MODAL fotos  -->

    <div>
      <b-modal
        id="modal-abastecimentoFotos"
        hide-footer
        size="lg"
        :title="`Cadastro de abastecimento Nº.: ${
          abastecimento.id == null ? '' : abastecimento.id
        }`"
        no-close-on-backdrop
      >
        <div class="d-flex justify-content-center" style="height: 80vh">
          <b-carousel
            id="carouselFoto"
            class="carouselFoto"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            background="#ababab"
            style="text-shadow: 1px 1px 2px #333"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide
              v-for="(photo, index) in abastecimento.fotos"
              :key="index"
              :img-src="photo"
            ></b-carousel-slide>
          </b-carousel>
        </div>
      </b-modal>
    </div>

    <!--  fim -  modal fotos do abastecimento  -->
    <!--  fim -  modal fotos do abastecimento  -->
    <!--  fim -  modal fotos do abastecimento  -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import * as XLSX from "xlsx";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "AbaLancamentos",

  computed: {
    ...mapState(["user"]),

    /*
    computed: {
      formattedValorTotal: {
        get() {
          const formattedValue = this.abastecimento.valor_total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          });
          console.log('Valor formatado:', formattedValue);
          return formattedValue;
        },
        // ...
      },
    },
*/

    itemsFiltered() {
      let valores = [];
      valores = this.abastecimentos.filter((item) => {
        const prefixo = item.prefixo || ""; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
        const id = item.id || "";
        const operador = item.registro || "";

        return (
          prefixo.indexOf(this.search) > -1 ||
          id.indexOf(this.search) > -1 ||
          operador.indexOf(this.search) > -1
        );
      });
      return valores;
    },
  },

  data: function () {
    return {
      dt_abastecimento: "",
      isLoading: false,

      slide: 0,
      sliding: null,

      empresas: [], // [] lista
      empresa: {},
      filiais: [], // [] lista
      filial: {},
      abastecimentos: [],
      abastecimento: {},
      nroabastecimento: null,
      formattedValorTotal: "", // Variável para armazenar o valor formatado

      bombas: [],
      responsabilidades: [],
      integracoes: [],
      montas: [],
      statuss: [], // [] lista
      abastecedor: [],

      mode: "save",
      carregando: false,
      atualizando: false,
      value_empresa: [], // [this.empresas],
      value_filial: [],
      value_status: [],
      //value_filial:[],// [] lista

      status: {},

      permissoes: [],
      permissao: {},

      abastecimento: {}, // [] lista
      abastecimentos: [], // [] lista
      pedidoferias: [], // implantado 08/07/2023
      sacT: {}, // [] lista
      abastecimentostratativa: [], // [] lista
      search: "",

      value_id_area: "",
      veiculos: [],
      operador: [],
      operadores: [],

      fields: [
        { key: "empresa_id", label: "Empresa", sortable: true },
        { key: "filial_id", label: "Filial", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data abastecimento",
          sortable: true,
          formatter: (value, key, abastecimentos) => {
            return moment(abastecimentos.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },
        { key: "prefixo", label: "Carro", sortable: true },
        { key: "combustivel", label: "Diesel", sortable: true },
        { key: "reposicao", label: "Óleo reposição", sortable: true },
        { key: "arla", label: "Arla", sortable: true },
        { key: "km_rodado", label: "Km rodado", sortable: true },
        { key: "od_inicial", label: "Odometro anterior", sortable: true },
        { key: "od_final", label: "Odometro atual", sortable: true },
        { key: "status", label: "status abastecimento", sortable: true },
        { key: "re_abastecedor", label: "RE Abastecedor", sortable: true },
        {
          key: "ultimo_abastecimento",
          label: "Data ultimo abastecimento",
          sortable: true,
          formatter: (value, key, abastecimentos) => {
            return moment(abastecimentos.ultimo_abastecimento)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_alteracao",
          label: "Data alteração",
          sortable: true,
          formatter: (value, key, abastecimentos) => {
            return moment(abastecimentos.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "observacoes", label: "Observações", sortable: true },
        { key: "actions", label: "Atualizar" },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },

  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },

    loadEmpresaCad() {
      let corpo = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFiliaisCad() {
      let corpo = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.filiais = res.data.map((fil) => {
            return { ...fil, value: fil.id_filial_erp, filial: fil.filial }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadBombas() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        filial_id: this.abastecimento.filial_id
          ? this.abastecimento.filial_id
          : this.value_filial.map((at) => at.id_filial_erp),
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/abastecimento/bomba/consulta`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.bombas = res.data.map((bom) => {
            return { ...bom, value: bom.id, bomba: bom.bomba }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadabastecimento() {
      this.isLoading = true; // Ative o indicador de carregamento
      let params = {
        empresa_id:
          this.value_empresa.length > 0
            ? `${this.value_empresa.map((e) => e.id_empresa)}`
            : this.user.id_empresa,
        filial_id:
          this.value_filial.length > 0
            ? `${this.value_filial.map((f) => f.id_filial_erp)}`
            : null,
        id_situacao:
          this.value_status.length > 0
            ? `${this.value_status.map((s) => s.id)}`
            : 2,
        dt_abastecimento: this.dt_abastecimento
          ? `${this.dt_abastecimento}`
          : null,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/abastecimento/lancamento/consultadetalhada`;
      axios
        .get(url, { params })
        .then((res) => {
          this.abastecimentos = res.data;
          this.isLoading = false; // Desative o indicador de carregamento
        })
        .catch(showError);
    },

    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.post(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadStatus() {
      const url = `${baseApiUrl}/abastecimento/lancamento/situacao`;
      axios.post(url).then((res) => {
        this.statuss = res.data.map((sta) => {
          return { ...sta, value: sta.id, status: sta.status };
        });
      });
    },

    gerarPlanilha() {
      // Objeto com os dados para a planilha
      const dados = this.pedidoferias;

      // Cria uma nova planilha
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(dados);

      // Adiciona a planilha ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

      // Salva o workbook como arquivo
      XLSX.writeFile(workbook, "pedido_de_ferias.xlsx");
    },

    loadCarregarabastecimento(abastecimento) {
      this.abastecimento = { ...abastecimento };
    },

    postabastecimento() {
      let corpo = {
        id: this.nroabastecimento
          ? this.nroabastecimento
          : `${this.abastecimento.id}`,
        dt_lancamento: `${this.abastecimento.dt_abastecimento}`,
        funcionario_id_cad: `${this.user.id_funcionario}`,
        empresa_id: `${this.abastecimento.empresa_id}`,
        filial_id: `${this.abastecimento.filial_id}`,
        carro_id:
          this.veiculos.length != 0
            ? `${this.veiculos.map((v) => v.id_veiculo)}`
            : this.abastecimento.carro_id,
        combustivel: `${this.abastecimento.combustivel}`,
        id_situacao: this.abastecimento.combustivel ? 2 : 1, // 2 = abastecido - 1 = não abasteceu
        reposicao: `${this.abastecimento.reposicao}`,
        arla: `${this.abastecimento.arla}`,
        carro_odometro_inicial: `${this.abastecimento.od_inicial}`,
        carro_odometro_final: `${this.abastecimento.od_final}`,
        km_rodado: this.abastecimento.od_final - this.abastecimento.od_inicial,
        abastecedor_id: `${this.abastecimento.uf}`,
        bomba_id: `${this.abastecimento.bomba_id}`,
        origem_id: `${this.abastecimento.ponto_referencia}`,
        abastecedor_id: this.abastecedor
          ? this.abastecedor.id_funcionario
          : null,
        observacoes: `${this.abastecimento.observacoes}`,
      };
      const url = `${baseApiUrl}/abastecimento/lancamento/cadastro`;
      axios
        .post(url, corpo)
        .then(() => {
          this.loadabastecimento;
          this.$toasted.global.defaultSuccess();
          this.reset(); //limpar os objetos valores
        })
        .catch(showError);
    },

    reset() {
      this.abastecimento = {};
      this.loadabastecimento();
      this.nroabastecimento = null;
    },

    limparFiltro() {
      this.search = "";
    },

    loadVeiculo() {
      let corpo = {
        id_empresa: `${this.user.id_empresa}`,
        prefixo: `${this.abastecimento.prefixo}`,
      };
      const url = `${baseApiUrl}/manutencao/frota/veiculo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.veiculos = res.data;
        })
        .catch(showError);
    },

    async loadOperador() {
      let corpo = {
        id_empresa: `${this.abastecimento.empresa_id}`,
        registro: `${this.abastecimento.re_abastecedor}`,
      };
      const url = `${baseApiUrl}/glo/escala/consulta`;
      axios.post(url, corpo).then((res) => {
        this.abastecedor = res.data;
      });
    },
  },

  mounted() {
    this.loadEmpresas();
    this.loadStatus();
    this.loadabastecimento();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.carouselFoto {
  max-width: 65%;
  height: auto;
  /* Defina a altura máxima que você deseja para as imagens */
  max-height: 100px;
}
</style>